(() => {
'use strict';
if (window.sunvaleKS1) return;
window.sunvaleKS1 = true;
function syncProduct(root, updateUrl=false) {
  const select=root.querySelector('[data-ks-variant]'), option=select?.selectedOptions[0];
  if (!option) return;
  document.querySelectorAll('.sv-ks [data-ks-sku]').forEach(n=>n.textContent=option.dataset.sku||'Not provided');
  root.querySelectorAll('[data-ks-color]').forEach(n=>n.textContent=option.dataset.title);
  const params=new URLSearchParams({source:'product',product:root.dataset.title,sku:option.dataset.sku||''});
  document.querySelectorAll('.sv-ks [data-ks-quote]').forEach(a=>a.href=(window.Shopify?.routes?.root||'/').replace(/\/?$/, '/')+'pages/wholesale?'+params+'#SunvaleWholesaleRFQ');
  root.querySelectorAll('[data-ks-whatsapp]').forEach(a=>a.href='https://wa.me/'+a.dataset.number+'?text='+encodeURIComponent(root.dataset.title+' / '+(option.dataset.sku||'')));
  if (updateUrl) {const u=new URL(location.href);u.searchParams.set('variant',option.value);history.replaceState(null,'',u);}
  // Family images deliberately do not respond to variant selection without verified photographic mapping.
}
function search(root) {
  const query=(root.querySelector('[data-ks-search]')?.value||'').trim().toLowerCase();
  let count=0;
  root.querySelectorAll('.product-grid .product-card').forEach(card=>{card.hidden=!!query&&!card.dataset.search.includes(query);if(!card.hidden)count++;});
  const label=root.querySelector('[data-ks-count]');if(label)label.textContent=(root.dataset.ksPageCount||'__COUNT__ products on this page').replace('__COUNT__',String(count));
  const empty=root.querySelector('[data-ks-empty]');if(empty)empty.hidden=count>0;
}
function init(scope) {
  const roots=[...(scope.matches?.('[data-ks-product]')?[scope]:[]),...scope.querySelectorAll('[data-ks-product]')];
  roots.forEach(root=>syncProduct(root));
}
document.addEventListener('change',e=>{
 const root=e.target.closest('[data-ks-product]');
 if(root&&e.target.matches('[data-ks-variant]'))syncProduct(root,true);
});
document.addEventListener('input',e=>{if(e.target.matches('[data-ks-search]'))search(e.target.closest('[data-ks-collection]'));});
document.addEventListener('click',e=>{
 const photo=e.target.closest('[data-ks-photo]');
 if(photo){e.preventDefault();const root=photo.closest('[data-ks-product]');root.querySelectorAll('[data-ks-panel]').forEach(p=>p.hidden=p.dataset.ksPanel!==photo.dataset.ksPhoto);root.querySelectorAll('[data-ks-photo]').forEach(a=>a.setAttribute('aria-current',String(a===photo)));return;}
 const view=e.target.closest('[data-ks-view]');
 if(view){const root=view.closest('[data-ks-collection]');root.querySelector('.product-grid').dataset.view=view.dataset.ksView;root.querySelectorAll('[data-ks-view]').forEach(b=>b.setAttribute('aria-pressed',String(b===view)));}
});
document.addEventListener('shopify:section:load',e=>init(e.target));
// Delegated handlers own no section observers, timers or per-section bindings to leak on unload.
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
})();

